// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YQE7","icon":"styles_icon__kqbA8"};